import React, { useState } from "react";
import ClickAwayListener from "@mui/material/ClickAwayListener";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import "./CustomSelect.css";

export interface SelectOption {
    value: string;
    label: string;
}

interface CustomSelectProps {
    value: string;
    options: SelectOption[];
    onChange: (value: string) => void;
    className?: string;
}

const CustomSelect = ({ value, options, onChange, className }: CustomSelectProps) => {
    const [isOpen, setIsOpen] = useState(false);

    const selectedLabel = options.find((opt) => opt.value === value)?.label || "";

    const handleSelect = (optValue: string) => {
        onChange(optValue);
        setIsOpen(false);
    };

    const handleClickAway = () => {
        setIsOpen(false);
    };

    return (
        <ClickAwayListener onClickAway={handleClickAway}>
            <div
                className={`custom-select-wrapper ${className || ""}`}
            >
                <button
                    type="button"
                    className={`custom-select-trigger ${isOpen ? "open" : ""}`}
                    onClick={() => setIsOpen(!isOpen)}
                >
                    <span className="custom-select-value">{selectedLabel}</span>
                    <KeyboardArrowDownIcon
                        className={`custom-select-arrow ${isOpen ? "rotated" : ""}`}
                        sx={{ fontSize: 16, color: "#1E1F2F" }}
                    />
                </button>

                {isOpen && (
                    <ul className="custom-select-options">
                        {options.map((opt) => (
                            <li
                                key={opt.value}
                                className={`custom-select-option ${opt.value === value ? "selected" : ""}`}
                                onClick={() => handleSelect(opt.value)}
                            >
                                {opt.label}
                            </li>
                        ))}
                    </ul>
                )}
            </div>
        </ClickAwayListener>
    );
};

export default CustomSelect;
